var map = {
	"./clientes_foto1.png": 13,
	"./home_cajaseca.png": 77,
	"./home_cajasecas.png": 78,
	"./home_cajasrefrigeradas.png": 79,
	"./home_foodgrade.png": 80,
	"./home_foto1.png": 14,
	"./home_foto2.png": 15,
	"./home_foto2_color.png": 81,
	"./home_foto3.png": 82,
	"./home_foto3_roja.png": 16,
	"./home_foto4.png": 83,
	"./home_foto5.png": 17,
	"./home_foto6.png": 84,
	"./home_plataforma.png": 85,
	"./home_plataformas.png": 86,
	"./home_tanque.png": 87,
	"./home_tanques.png": 88,
	"./home_tractocamion.png": 89,
	"./home_tractocamiones.png": 90,
	"./inventario_cajas.png": 91,
	"./inventario_cajasecas.png": 92,
	"./inventario_cajasrefrigeradas.png": 93,
	"./inventario_foodgrade.png": 94,
	"./inventario_plataforma.png": 95,
	"./inventario_plataformas.png": 96,
	"./inventario_tanques.png": 97,
	"./inventario_tractocamiones.png": 98,
	"./nosotros_foto1.png": 18,
	"./nosotros_foto2.png": 19,
	"./servicios_foto1.png": 20,
	"./servicios_foto2.png": 99
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\.png$
// module id = 7
// module chunks = 0